import type { UseBiddingViewName } from '../../BiddingSection/useBiddingViewName';

export const VALID_SHORTLIST_BUTTON_VIEW_NAMES: UseBiddingViewName[] = ['saleActive', 'buyItNow', 'saleOverProcessing'];
